import React from 'react';
import { useLang } from '../context/LangContext';
import CartContent from '../components/CartContent';
import PageHeader from '../lib/ui/PageHeader';

export default function CartPage() {
  const { lang, t } = useLang();
  const te = lang === 'te';

  return (
    <div className="max-w-2xl mx-auto">
      <PageHeader title={`${t.cartTitle} 🛒`} sub={te ? 'మీ ఆర్డర్‌ను సమీక్షించండి' : 'Review your order'} />
      <div className="px-4 md:px-6 pt-4">
        <CartContent />
      </div>
    </div>
  );
}
